
import { defineComponent } from "vue";

export default defineComponent({
  name: "TopBar",
  props: ["layout", "darkModeText", "darkMode"],
  setup(props) {
    const { layout, darkModeText, darkMode } = props;
    const title = "וורדל - " as string;
    const openSettings = () => {
      layout.main = false;
      layout.info = true;
      layout.settings = false;
    };
    const openInfo = () => {
      layout.settings = true;
      layout.main = false;
      layout.info = false;
    };
    return { title, openSettings, openInfo, darkModeText, darkMode };
  },
});
